import i18next from 'i18next';

import { getFormattedDate } from '@/utils/date';

interface CompletionStatusParams {
  timeSpentHrs: number;
  timeSpentMins: number;
  completionDate?: string;
  expirationDate?: string;
  certificatesEpicEnabled?: boolean;
  planType?: string;
}

export const getCompletionStatusText = ({
  timeSpentHrs,
  timeSpentMins,
  completionDate,
  expirationDate,
  // These two props can be removed once the certificates epic is fully rolled out
  certificatesEpicEnabled = false,
  planType,
}: CompletionStatusParams): string => {
  // Override: if certificatesEpic flag is enabled, use completion date as expiration date for compliance plans
  let effectiveExpirationDate = expirationDate;
  if (
    certificatesEpicEnabled &&
    !expirationDate &&
    planType?.toLowerCase() === 'compliance'
  ) {
    effectiveExpirationDate = completionDate;
  }

  const timeSpent =
    timeSpentHrs > 0
      ? `${timeSpentHrs} ${i18next.t('Generic.hours', { count: timeSpentHrs })} ${timeSpentMins} ${i18next.t('Generic.minutes', { count: timeSpentMins })}`
      : `${timeSpentMins} ${i18next.t('Generic.minutes', { count: timeSpentMins })}`;

  const completionText = i18next.t('Generic.completedOnDateInTime', {
    completionDate: getFormattedDate(completionDate),
    timeSpent,
  });

  const certificationText = effectiveExpirationDate
    ? ` • ${i18next.t('Generic.certifiedUntil', {
        expirationDate: getFormattedDate(effectiveExpirationDate),
      })}`
    : '';

  return completionText + certificationText;
};
